
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"5","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.12.399h2.76l-.51 10.409H1.63L1.12.398zm1.37 11.513c.45 0 .838.143 1.145.43.286.286.45.654.45 1.104 0 .45-.164.838-.45 1.124A1.66 1.66 0 012.49 15a1.51 1.51 0 01-1.105-.45c-.327-.286-.47-.654-.47-1.104 0-.45.143-.818.47-1.104.287-.287.655-.43 1.105-.43z","fill":"#FFFDFD"}})])
          )
        }
      }
    